import React, { ReactElement } from 'react';
import classNames from 'classnames';

import { SkapiecOffer } from 'interfaces/company.interface';
import Link from 'atomic/link/link';
import Button from 'atomic/button/button';
import Rating from 'atomic/rating/rating';

import './company-view-best-offers-item.scss';

interface CompanyViewBestOffersItemProps extends SkapiecOffer {
    isMobile?: boolean;
}

const CompanyViewBestOffersItem: React.FC<CompanyViewBestOffersItemProps> = ({
    isMobile = false,
    productName,
    productPhotoUrl,
    offerUrl,
    price,
    opineoProductId,
    opineoProductSlug,
    opineoProductAverageRating
}): ReactElement => {
    const priceNumber = Math.round(price);
    const priceDecimal = Math.round(price * 100 % 100);
    const priceDecimalString = priceDecimal < 10 ? `0${priceDecimal}` : String(priceDecimal);

    const handleClickOffer = (): void => window.dataLayer.push({
        event: 'productBestOffer',
        eventCategory: '',
        eventAction: 'widgetClickOffer',
        eventLabel: ''
    });

    return (
        <div className="best-offers-item">
            <Link className="best-offers-item__main" href={offerUrl} wrapper={true}
                target="_blank" onClick={handleClickOffer}
            >
                <span className="best-offers-item__img-wrapper">
                    <img src={productPhotoUrl} alt={productName} className="best-offers-item__img"
                        loading="lazy"
                    />
                </span>
                <h3 className="best-offers-item__name">
                    {productName}
                </h3>
                <Button className="best-offers-item__buy">
                    Kup
                </Button>
                <span className="best-offers-item__price-wrapper">
                    od
                    {' '}
                    <strong className="best-offers-item__price">
                        {priceNumber}
                        <sup>
                            {priceDecimalString}
                        </sup>
                    </strong>
                    {' '}
                    zł
                </span>
            </Link>
            {opineoProductId && opineoProductSlug && (
                <Link
                    className={classNames('best-offers-item__rating', { 'best-offers-item__rating--show-cta': !isMobile })}
                    href={`/opinie-${opineoProductId}-${opineoProductSlug}.html`}
                    wrapper={true}
                >
                    <Rating value={opineoProductAverageRating || 0} readOnly={true} className="best-offers-item__rating-stars"
                        width={75}
                    />
                    {!isMobile && (
                        <Button className="best-offers-item__rating-add" color="white">
                            Dodaj opinię
                        </Button>
                    )}
                </Link>
            )}
        </div>
    );
};

export default CompanyViewBestOffersItem;
